import React from 'react'
import "./BackButton.css"
import { TbArrowLeft } from 'react-icons/tb'
import { useNavigate } from 'react-router-dom';

export default function BackButton({ location }) {
    const navigate = useNavigate();
    return (
        <span onClick={() => navigate(location)} className='general-back-button'>
            <TbArrowLeft color='rgba(71, 84, 103, 1)' />
        </span>
    )
}
